// extracted by mini-css-extract-plugin
export default {"main__title_wrapper":"Catalog_main__title_wrapper__9UCMY","main__catalog_title":"Catalog_main__catalog_title__ZCakz"};